import React from 'react';
import styled from 'styled-components';
import { styles, SdiAdd, TextLink } from '@sdir/sds';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { routes } from '../../../constants/routes';
import { getRouteForLanguage } from '../../../helpers/languageHelpers';

const StartNewAppTile: React.FC = () => {
  const intl = useIntl();

  return (
    <Link to={getRouteForLanguage(intl.locale, routes.newApplication)}>
      <TileBody data-testid="certificate-tile">
        <Icon>
          <SdiAdd color={styles.colors.primary} size="l" />
        </Icon>
        <StartAppLink>
          <TextLink text={intl.formatMessage({ id: 'certificates.page.newApp' })} />
        </StartAppLink>
      </TileBody>
    </Link>
  );
};

const TileBody = styled.div`
  display: grid;
  align-items: center;
  width: 224px;
  height: 136px;
  box-shadow: ${({ theme }) => theme.card.boxShadow};
  border-radius: ${({ theme }) => theme.card.borderRadius};
  background-color: ${({ theme }) => theme.colors.background.secondary};
  transition: 250ms ease;
  &:hover {
    background: #ccd9e3;
    transition: 250ms ease;
  }
`;
const StartAppLink = styled.div`
  margin: -30px auto 0 auto;
`;
const Icon = styled.div`
  margin: 0 auto;
`;
export default StartNewAppTile;
